

import React, { useState } from 'react';
import './Legal.css';

const DataDeletion = () => {
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    reason: '',
    confirm: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.confirm) {
      alert('Please confirm your request');
      return;
    }
    alert('Your data deletion request has been submitted. We will process it within 30 days and send confirmation to your email.');
    setFormData({ email: '', phone: '', reason: '', confirm: false });
  };

  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Data Deletion Request</h1>
          <p>Request deletion of your personal data from MOJ systems</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="deletion-grid">
            <div className="deletion-info">
              <h2>Before You Proceed</h2>
              <div className="info-box">
                <h3>⚠️ Important Information</h3>
                <ul>
                  <li>Account deletion is permanent and cannot be undone</li>
                  <li>Active rides must be completed before deletion</li>
                  <li>Pending payments must be settled</li>
                  <li>Some data may be retained for legal compliance (up to 6 years)</li>
                  <li>Process may take up to 30 days to complete</li>
                </ul>
              </div>

              <h3>What Gets Deleted</h3>
              <ul className="deletion-list">
                <li>✓ Personal profile information</li>
                <li>✓ Ride history and locations</li>
                <li>✓ Payment methods (except records required by law)</li>
                <li>✓ App preferences and settings</li>
                <li>✓ Marketing preferences</li>
              </ul>

              <h3>What We Retain</h3>
              <ul className="retention-list">
                <li>✗ Transaction records (tax/legal requirements)</li>
                <li>✗ Dispute and incident reports</li>
                <li>✗ Data required by transport regulations</li>
              </ul>
            </div>

            <div className="deletion-form-container">
              <h2>Submit Deletion Request</h2>
              <form onSubmit={handleSubmit} className="deletion-form">
                <div className="form-group">
                  <label>Registered Email *</label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    placeholder="Enter your registered email"
                  />
                </div>

                <div className="form-group">
                  <label>Registered Phone Number *</label>
                  <input
                    type="tel"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    placeholder="03XX-XXXXXXX"
                  />
                </div>

                <div className="form-group">
                  <label>Reason for Deletion (Optional)</label>
                  <select
                    value={formData.reason}
                    onChange={(e) => setFormData({...formData, reason: e.target.value})}
                  >
                    <option value="">Select a reason</option>
                    <option value="not-using">No longer using the service</option>
                    <option value="privacy">Privacy concerns</option>
                    <option value="switching">Switching to another service</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group checkbox-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={formData.confirm}
                      onChange={(e) => setFormData({...formData, confirm: e.target.checked})}
                    />
                    <span>I understand that this action is irreversible and I have read the information above *</span>
                  </label>
                </div>

                <button type="submit" className="btn-primary" style={{width: '100%', backgroundColor: '#d32f2f'}}>
                  Request Data Deletion
                </button>
              </form>

              <div className="alternative-contact">
                <p>Having trouble? Email us directly at <a href="mailto:info@mojexpress.com">info@mojexpress.com</a> with subject "Data Deletion Request"</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataDeletion;
